import styled from "styled-components";
import Block, { BlockContent } from "~/components/Block";
import { getCommonSliceProps } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

const VideoWrapper = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 56%;
  position: relative;
  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

function YoutubeVideoSlice(props) {
  const {
    spacingTop = 0,
    spacingBottom = 6,

    backgroundColor,
    color,
    highlightColor,

    youtubeId,
    youtubeList,
    controls,
  } = props;

  if (!youtubeId) return null;

  // console.log('YT');
  // console.log(youtubeId, youtubeList);

  let url =
    `https://www.youtube.com/embed/${youtubeId}` +
    `?controls=${controls ? "1" : "0"}` +
    `&modestbranding=1`;

  if (youtubeList) {
    url =
      `https://www.youtube.com/embed/videoseries` +
      `?list=${youtubeList}` +
      `&loop=1` +
      `&controls${controls ? "1" : "0"}` +
      `&modestbranding=1`;
  }

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <VideoWrapper>
          <div>
            <iframe
              width="100%"
              height="100%"
              src={url}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </VideoWrapper>
      </BlockContent>
    </Block>
  );
}

export function mapSliceToProps(slice) {
  const { primary, items = [] } = slice;

  // console.log('YOUTUBE VIDEO', slice);

  // "https://www.youtube.com/watch?v=T4FNNi4SezY"

  // remove pathname
  let youtubeId = null;
  let youtubeList = null;

  if (primary.youtube_video_link) {
    try {
      let query = primary.youtube_video_link.url.split("?");
      query = `?${query[query.length - 1]}`;
      youtubeId = new URLSearchParams(query).get("v");
      youtubeList = new URLSearchParams(query).get("list");

      // use videolink
      // https://www.youtube.com/watch?v=4g3gQerhkh0
      // or link w list
      // https://www.youtube.com/watch?v=4g3gQerhkh0&list=PLWa4R2I19VH7Mtxo3VvqwnNlXgLpf4_d3
    } catch (err) {}
  }

  const props = {
    ...getCommonSliceProps(slice),
    // link: primary.youtube_video_link
    youtubeId,
    youtubeList,
    controls: primary.controls === "Yes" ? "1" : "0",
  };

  return props;
}

export default connectSlice(mapSliceToProps)(YoutubeVideoSlice);
